import React from 'react';
import {
  validateEmailAddress,
  validateEmpty,
  validatePhoneNumber,
} from 'utils/validators';
import TextFieldInput from 'components/common/TextFieldInput/TextFieldInput';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const RequestToBookParticipantFormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 12px;
  row-gap: 24px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const RequestToBookParticipantForm = () => {
  const { t: translateText } = useTranslation();

  return (
    <RequestToBookParticipantFormContainer>
      <TextFieldInput
        name="participant.firstName"
        label={translateText('firstName')}
        placeholder="Enter"
        required
        rules={{
          ...validateEmpty(),
        }}
      />
      <TextFieldInput
        name="participant.lastName"
        label={translateText('lastName')}
        placeholder="Enter"
        required
        rules={{
          ...validateEmpty(),
        }}
      />
      <TextFieldInput
        name="participant.emailAddress"
        label={translateText('email')}
        placeholder="Enter"
        required
        rules={{
          ...validateEmpty(),
          ...validateEmailAddress(),
        }}
      />
      <TextFieldInput
        name="participant.phoneNumber"
        label={translateText('phoneNumber')}
        placeholder="Enter"
        rules={{
          ...validatePhoneNumber(),
        }}
      />
    </RequestToBookParticipantFormContainer>
  );
};

export default RequestToBookParticipantForm;
